import { SendMailStep } from "@complex/SendMailModal/stepper";
import { Button } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";

interface ISendMailModalRecipientsActionsProps {
  onClose: () => void;
  setStep: Dispatch<SetStateAction<SendMailStep>>;
}

export const SendMailModalRecipientsActions = ({ onClose, setStep }: ISendMailModalRecipientsActionsProps) => {
  return (
    <>
      <Button onClick={onClose} color="primary" variant="outlined" aria-labelledby="Annuler">
        Annuler
      </Button>
      <Button
        onClick={() => setStep(SendMailStep.MAIL_CONTENT)}
        color="primary"
        variant="contained"
        aria-labelledby="Suivant"
      >
        Suivant
      </Button>
    </>
  );
};
